import { Url } from "finhelper";
import { createReducer } from "redux-act";

import en from "../../translations/en";
import ru from "../../translations/ru";

let data: Record<string, any> = {};

const lang: string | null = localStorage.getItem("language_id");

const url = Url.getCurrentUrl();

if (url.includes("/ru/")) {
    data = ru;
} else if (url.includes("/en/")) {
    data = en;
} else if (parseInt(lang as string, 10) === 1 || lang === null) {
    data = ru;
} else {
    data = en;
}

const reducer = createReducer<Record<string, any>>({}, data);

export default reducer;
